"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
// const ref = React.createRef()
// const ref = useRef()
exports.default = (0, mobx_react_1.observer)(({ field }) => (react_1.default.createElement("div", { className: "measure" },
    react_1.default.createElement("label", { htmlFor: field.id, className: "f7 db mb2 mt3 light-silver" }, field.label),
    react_1.default.createElement("input", Object.assign({ className: "input-reset ba b--black-10 br1 pa2 mb2 db w-100 f6", "aria-describedby": "name-desc" }, field.bind())),
    react_1.default.createElement("small", { className: "f6 db red" }, field.error))));
